import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { SlotGameType1_Responsive } from "../SlotGameType1_Responsive";

export class MayanHeroesFillingPot_Responsive extends SlotGameType1_Responsive {

        
    protected override helpFactory: IHelpFactory = new MayanHeroesFillingPotHelpFactory();
    //LED COLOR
    protected override ColorLed: string = "0,139,139\n";
    constructor(multigameParams: MultigameParams, initData: SlotGameInitData, gameName: string = "MayanHeroesFillingPot") {
        super(multigameParams, initData, gameName);

        this.spinnableReelsParams.topBorderWidth = 8;
        this.spinnableReelsParams.bottomBorderWidth = 8;
    }

    // protected PrepareFonts(resourceManager: ResourceManager): void {

    //     resourceManager.Add(new FontResource(this.basepath + "resources/Monky Stone.ttf", this.resid.ScopedResourceName(["BigSymbolFreeGames-font"])));

    // }
}
//Help Colorized
class MayanHeroesFillingPotHelpFactory implements IHelpFactory {
    public CreateNewHelp(params: HelpParameters): Help {
        return new MayanHeroesFillingPotHelp(params);
    }
}

class MayanHeroesFillingPotHelp extends Help {
    protected override BackgroundPanel(): HelpPanelColor {
        let color: HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(31, 75, 60),rgb(40, 77, 71), rgb(103, 146, 139),rgb(40, 77, 71),rgb(31, 75, 60)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

        return color;
    }
}